import axios from 'axios';
const { REACT_APP_API_URL } = process.env;

const httpClient = axios.create({
    baseURL: REACT_APP_API_URL,
    headers: {
        Accept: 'application/json'
    }
});

export default httpClient;
